import { render, staticRenderFns } from "./ExcluirComprometimentosEmLote.vue?vue&type=template&id=357a3482&"
import script from "./ExcluirComprometimentosEmLote.vue?vue&type=script&lang=js&"
export * from "./ExcluirComprometimentosEmLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports